import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68692d7d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-management-modal-delete__title" };
const _hoisted_2 = { class: "dialog" };
import { reactive, watch, computed } from 'vue';
import { useToast } from 'vue-toastification';
import { deleteAudience } from '../data';
import bus from '@/helpers/events/bus';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManagementModalDelete',
    props: {
        isVisible: { type: Boolean },
        audience: {}
    },
    emits: ['resetDeleteAudience', 'resetModalVisibility'],
    setup(__props, { emit }) {
        const props = __props;
        const toast = useToast();
        const state = reactive({
            isVisible: false,
        });
        const isVisibleModal = computed(() => props.isVisible);
        const hideDeleteModal = () => {
            emit('resetDeleteAudience');
            emit('resetModalVisibility');
        };
        const confirmDelete = () => {
            deleteTrigger(props.audience);
            hideDeleteModal();
        };
        const deleteTrigger = (audience) => {
            const params = {
                audienceId: audience.id,
                enabled: 0,
            };
            deleteAudience(params).then(response => {
                if (response) {
                    toast.success(i18n.global.t('audiences.delete.success'), { timeout: 10000 });
                    bus.$emit('render-cards');
                    return;
                }
                toast.error(i18n.global.t('audiences.delete.error'), { timeout: 5000 });
            });
        };
        watch(isVisibleModal, () => {
            state.isVisible = props.isVisible;
        }, { immediate: true });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                width: 500,
                modelValue: state.isVisible,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.isVisible) = $event)),
                "before-close": hideDeleteModal,
                class: "audience-management-modal-delete"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('audiences.do-you-want-delete')), 1),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: "cancel btn btn-secondary",
                            onClick: hideDeleteModal
                        }, _toDisplayString(_ctx.$t('cancel')), 1),
                        _createElementVNode("div", {
                            class: "confirm btn",
                            onClick: confirmDelete
                        }, _toDisplayString(_ctx.$t('confirm')), 1)
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
